import React, { useState } from 'react'
import {Typography, Button, IconButton, CardContent, TextField } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import styled from 'styled-components'
import { FlexView } from '../../components/common'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

const Instruction = styled.span`
  font-weight: normal;
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${({ theme }) => theme.fontSizes.small};
  text-align: left;
  margin: 0px 5px 34px;
`

const ChangePasswordForm = ({ setLoading, updateValue, changePassword, signOut, onBackClick }) => {
  const { t } = useTranslation()
  const [confirmPassword, setConfirmPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')

  const onSubmit = changePassword && (async e => {
    e.preventDefault()
    if (confirmPassword === newPassword) {
      setLoading(true)
      try {
        await changePassword(newPassword)
        await signOut()
        toast.success(t('login.messages.passwordChanged'))
        setLoading(false)
      }
      catch (errorMessage) {
        toast.error('Invalid informations. Please try again.')
        setLoading(false)
      }
    }
    else {
      toast.error(t('login.errors.PasswordMatchError'))
    }
  })

  return (
    <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', margin: '20px', marginTop: '0px' }} >
      <Typography variant="h6" color="textSecondary" component="h2" sx={{ marginBottom: '30px'}}>
        <IconButton aria-label="back" onClick={onBackClick}><ArrowBackIcon /></IconButton>
        {t('login.newPasswordLabel')}
      </Typography>

      <Instruction>The new password must have min 8 characters with numbers, uppercase and lowercase letters and especial characters</Instruction>
      
      <TextField id="newPassword" name="newPassword" label={t('new password')} value={newPassword} type="password" required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}} onChange={updateValue(setNewPassword)} error={newPassword !== undefined && !newPassword} sx={{ marginBottom: '20px'}} />
          
      <TextField id="confirmPassword" name="confirmPassword" label={t('confirm password')} value={confirmPassword} type="password" required fullWidth size="small" variant="outlined" InputLabelProps={{shrink: true}} onChange={updateValue(setConfirmPassword)} error={confirmPassword !== undefined && !confirmPassword} sx={{ marginBottom: '20px'}} />
      
      <FlexView flexDirection="row" alignItems="center" justifyContent="flex-end" width="100%" margin="15px 0px 5px">
        <Button disabled={!newPassword || !confirmPassword} variant="contained" onClick={onSubmit}>{t('Change')}</Button>
      </FlexView>
   </CardContent>
  )
}

export default ChangePasswordForm